import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-ot-bg text-ot-fg">
      {/* Skip to content for keyboard / screen reader users */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-ot-indigo focus:text-white focus:px-4 focus:py-2 focus:border-2 focus:border-ot-fg focus:outline-none"
      >
        Skip to main content
      </a>
      <NavBar />
      <main id="main" className="flex-1" data-testid="main-content" role="main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
